import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onClose"];
import { useState } from 'react';
import TwoFactorPrompt from '../components/TwoFactorPrompt';
import { TwoFactorRecoveryModal } from '../components/recovery/TwoFactorRecoveryModal';
import { TwoFactorRecoveryContext } from '../contexts/twoFactorRecovery';
import { useTwoFactorRecovery } from '../hooks/useTwoFactorRecovery';
import PrecedenceLevels from '../constants/precedenceLevels';
import { jsx as _jsx } from "react/jsx-runtime";
export default function TwoFactorPromptContainer(_ref) {
  let {
      onClose
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [precedence, setPrecedence] = useState(PrecedenceLevels.PRIMARY);
  const twoFactorRecoveryState = useTwoFactorRecovery(precedence);
  return twoFactorRecoveryState.twoFactorRecoveryOpen ? /*#__PURE__*/_jsx(TwoFactorRecoveryContext.Provider, {
    value: twoFactorRecoveryState,
    children: /*#__PURE__*/_jsx(TwoFactorRecoveryModal, {})
  }) : /*#__PURE__*/_jsx(TwoFactorPrompt, Object.assign({}, props, {
    onSuccess: data => {
      onClose();
      props.onSuccess(data);
    },
    openTwoFactorRecovery: twoFactorRecoveryState.openTwoFactorRecovery,
    precedence: precedence,
    setPrecedence: setPrecedence
  }));
}